import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { attributesMatchDefault } from '../../utils/attributes-match-default';
var isHeaderRow = function isHeaderRow(row) {
  return row.child(0).type.name === 'tableHeader';
};
var isFirstRow = function isFirstRow(row, parent) {
  return parent.content.child(0) === row;
};
var isHeaderRowPresent = function isHeaderRowPresent(table) {
  var headerRowPresent = false;
  table.content.forEach(function (row) {
    if (isHeaderRow(row)) {
      headerRowPresent = true;
    }
  });
  return headerRowPresent;
};
var _renderNode = function renderNode(state, node, index) {
  if (index > 0) {
    state.write(' ');
  }
  node.content.forEach(function (child, i) {
    if (child.isTextblock || child.type.name === 'mediaSingle') {
      if (i > 0) {
        state.write(' ');
      }
      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      state.context.insideTable = true;
      state.renderInline(child);
      // Ignored via go/ees005
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      state.context.insideTable = false;
    } else {
      _renderNode(state, child, i);
    }
  });
};
var renderInlineContent = function renderInlineContent(_ref) {
  var state = _ref.state,
    node = _ref.node;
  state.write('| ');
  _renderNode(state, node, 0);
  state.write(' ');
};
var tableNodes = {
  table: {
    serialize: function serialize(_ref2) {
      var state = _ref2.state,
        node = _ref2.node,
        parent = _ref2.parent,
        index = _ref2.index;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'table',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"table_open\" data-id=\"".concat(id, "\" />\n\n"));
        node.content.forEach(function (child, i) {
          return state.render(child, node, i);
        });
        state.write("<custom data-type=\"table_close\" />\n\n");
      } else {
        if (!attributesMatchDefault(node, state.featureToggles, {
          layout: node.attrs.layout,
          localId: node.attrs.localId,
          width: 760
        })) {
          state.updateNonErrorFallbackState(node);
        }
        var headerRowPresent = isHeaderRowPresent(node);
        node.content.forEach(function (child, i) {
          try {
            state.render(child, node, i, {
              headerRowPresent: headerRowPresent,
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        });
        state.closeBlock(node);
      }
    },
    support: 'partial'
  },
  tableRow: {
    serialize: function serialize(_ref3) {
      var state = _ref3.state,
        node = _ref3.node,
        parent = _ref3.parent,
        index = _ref3.index,
        options = _ref3.options;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'table',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"tr_open\" data-id=\"".concat(id, "\" />\n\n"));
        node.content.forEach(function (child, i) {
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        });
        state.write("<custom data-type=\"tr_close\" />\n\n");
      } else {
        if (!attributesMatchDefault(node, state.featureToggles)) {
          state.updateNonErrorFallbackState(node);
        }
        node.content.forEach(function (child, i) {
          try {
            state.render(child, node, i, _objectSpread(_objectSpread({}, options), {}, {
              skipFallback: true
            }));
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        });
        state.write('|');
        state.ensureNewLine();
        if (isHeaderRow(node) || isFirstRow(node, parent)) {
          for (var i = 0; i < node.childCount; i++) {
            state.write('| --- ');
          }
          state.write('|');
          state.ensureNewLine();
        }
      }
    },
    support: 'partial'
  },
  tableHeader: {
    serialize: function serialize(_ref4) {
      var state = _ref4.state,
        node = _ref4.node,
        parent = _ref4.parent,
        index = _ref4.index,
        options = _ref4.options;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'table',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"th_open\" data-id=\"".concat(id, "\" />\n\n"));
        node.content.forEach(function (child, i) {
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        });
        state.write("<custom data-type=\"th_close\" />\n\n");
      } else {
        if (!attributesMatchDefault(node, state.featureToggles)) {
          state.updateNonErrorFallbackState(node);
        }
        renderInlineContent({
          state: state,
          node: node,
          parent: parent,
          index: index,
          options: options
        });
      }
    },
    support: 'partial'
  },
  tableCell: {
    serialize: function serialize(_ref5) {
      var state = _ref5.state,
        node = _ref5.node,
        parent = _ref5.parent,
        index = _ref5.index,
        options = _ref5.options;
      if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
        var id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : "id-".concat(state.idCounter++);
        state.idMap[id] = {
          type: 'table',
          attributes: node.attrs
        };
        state.write("<custom data-type=\"td_open\" data-id=\"".concat(id, "\" />\n\n"));
        node.content.forEach(function (child, i) {
          try {
            state.render(child, node, i, {
              skipFallback: true
            });
          } catch (error) {
            state.updateFallbackState(error, node);
            state.nodes.fallback.serialize({
              state: state,
              node: node,
              parent: parent,
              index: index
            });
          }
        });
        state.write("<custom data-type=\"td_close\" />\n\n");
      } else {
        if (!attributesMatchDefault(node, state.featureToggles)) {
          state.updateNonErrorFallbackState(node);
        }
        renderInlineContent({
          state: state,
          node: node,
          parent: parent,
          index: index,
          options: options
        });
      }
    },
    support: 'partial'
  }
};
export default tableNodes;